import React from 'react'
import "./About_banner.css"
import Banner_heading from '../../common/banner_heading/Banner_heading'

function About_banner() {
    return (
        <>
            <section className='About_banner bg_img_holder'>
                <div className="container">

                    <Banner_heading heading_text_1="Built For  " span_tag="Tenants " heading_text_2="Powered By Convenience" />
                    <div className="text_holder">
                        <p>From smart reminders to one-tap payments, our app is designed to help you manage your monthly dues without the hassle.</p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About_banner